export const ALARM_DATE_FIELDS = {
	preWarningAt: 'Pre Warning',
	preWarningStopAt: 'Pre Warning Stop',
	firingAt: 'Firing',
	firingStopAt: 'Firing Stop',
	ackAt: 'Ack',
	unackAt: 'Unack',
} as const;

export type ALARM_DATE_FIELDS = keyof typeof ALARM_DATE_FIELDS;
